import React, { FC } from 'react'

import { ProductFeatureCard } from '../../../../components/product-feature-card/ProductFeatureCard'
import { ProcessingFeatureCard } from '../processing-feature-card/ProcessingFeatureCard'

import gpuIcon from '../../assets/gpu.svg'
import speedIcon from '../../assets/speed.svg'
import parallelIcon from '../../assets/parallel.svg'
import waveIcon from '../../assets/wave.svg'

import classes from './style.module.scss'

export const AccelerationCards: FC = () => {
  return (
    <div className={classes.container}>
      <ProductFeatureCard 
        icon={gpuIcon} 
        text="Tap into powerful GPU resources" 
        className={classes.productCard}
      />
      <ProductFeatureCard 
        icon={speedIcon} 
        text="Overcome long-standing CPU and DSP limitations" 
        className={classes.productCard}
      />
      <ProcessingFeatureCard className={classes.processingCard} />
      <ProductFeatureCard 
        icon={parallelIcon} 
        text="Unlock massive parallel processing capacity" 
        className={classes.productCard}
      />
      <ProductFeatureCard 
        icon={waveIcon} 
        text="Futurize how audio is created, processed, and delivered" 
        className={classes.productCard}
      />
    </div>
  )
}